export default {
  en: {
    simulator: {
      atccomponent: {
        paidnotice: 'The simulator is only accessible by paid users',
        verifiednotice: 'The simulator is only accessible by verified users',
        sessionloaded: 'Session loaded',
        licensemissing: 'Simulator license is not available',
        demoused: 'You have access to {transmissions} transmissions a day, but you can upgrade to a full seat to get unlimited access.',
        purchase: {
          seat: 'Purchase a full seat',
          simulator: 'Purchase the simulator license',
        },
        efb:{
          tab: {
            flight: 'Flight',
            instruments: 'Instruments',
            flightplan: 'Flight plan',
            settings: 'Settings',
            sessions: 'Sessions',
          },
          tabs: {
            flight: {
              airplane: 'Airplane',
              callsign: 'Callsign/Registration',
              icao: 'Starting airport (ICAO code)',
              flightrule: 'Flight Rule',
              notes: 'Be advised that this data is not known to ATC if not transmitted or observable.',
            },
            flightplan: {
              starting_aerodrome: 'Starting aerodrome (ICAO code)',
              unknown_distance: 'Unknown distance',
              title_runway_heading: 'Runway heading',
              destination_aerodrome: 'Destination aerodrome (ICAO code)',
            },
            settings: {
              blur:'Blur ATC messages',
              radioquality:'Simulate radio quality',
              autochange:'Autochange frequency',
              resetaircraft:'Keep aircraft on reset',
              resetcallsign:'Keep callsign on reset',
            },
            instruments:{
              transponder: 'Transponder',
              frequency_hint: 'Find your frequencies on our tool page right <a href="{link}" target="_blank" class="ui-link blue">here</a>',
              active_frequency: 'Active frequency',
              alternate_frequency: 'Alternate frequency',
              transpondermode: 'Transponder mode',
              illumination: 'Illumination',
              switchbeacon: 'Beacon',
              switchnav: 'Nav',
              switchstrobe: 'Strobe',
              switchlanding: 'Landing',
              switchtaxi: 'Taxi',
            },
            sessions: {
              firsttransmission: 'First transmission',
              select: 'Select',
              transmissions: 'Transmissions',
              hoursago: 'hours ago',
              minutesago: 'minutes ago',
              nosessions: 'No sessions found'
            }
          },
          explaintab: 'Explain this tab',
          explain: {
            tabflight: {
              airplane: 'Here you select the airplane of your choice.<br><br>Be adviced that the ATC may not let you leave with a 747 when starting from a grass strip.',
              callsign: 'This is the callsign you will need to use when talking to ATC.<br><br>It is required to pronounce the callsign in a ICAO format.<br><br>Example: <strong>G-ABCD</strong> will be pronounced as <strong>Golf Alfa Bravo Charlie Delta</strong>',
              icao: 'This is the ICAO code of the airport you are at.<br><br>You are required to provide a correct aerodrome code',
              flightrule: 'This is the flight rule you are flying under.<br><br>VFR = Visual Flight Rules<br>IFR = Instrument Flight Rules',
            },
            tabinstruments: {
              activefreq: 'This is the frequency you are currently using to communicate with ATC.',
              swapper: 'This button allows you to swap the active and alternate frequencies.',
              alternatefreq: 'This is the frequency you are not currently using to communicate with ATC.',
              squawk: 'The squawk code is a four-digit code assigned by ATC to identify your aircraft on radar.',
              mode: 'This is the mode of your transponder. It can be set to different modes depending on the situation.',
              illumination: 'This is the illumination of your aircraft lights. It is important to have them on when flying at night or in low visibility conditions.',
            },
            tabflightplan: {
              startingaerodrome: 'This is the ICAO code of the aerodrome you are starting from.<br><br>You are required to provide a correct aerodrome code',
              distance: 'This is the distance between your starting aerodrome and your destination aerodrome.<br><br>If it shows "Unknown distance", it means that one of the aerodromes is not valid.',
              heading: 'This is the direction from the starting aerodrome to the destination aerodrome.<br><br>The flight will roughly be aligned with this heading.',
              swap: 'This button allows you to swap the starting and destination aerodromes.',
              destinationaerodrome: 'This is the ICAO code of the aerodrome you are flying to.<br><br>You are required to provide a correct aerodrome code',
            },
            tabsettings: {
              blur: 'Blur the transmissions to prevent reading and enforece listening.',
              radioquality: 'This setting simulates the quality of the radio communication, adding static and dropouts.',
              autochange: 'This setting enables the automatic frequency change when instructed by ATC.',
              resetaircraft: 'This setting keeps your selected aircraft when resetting the simulator.',
              resetcallsign: 'This setting keeps your entered callsign when resetting the simulator.',
            },
            tabsessions:{
              tabexplain: 'Here you can load previous sessions of the simulator.<br><br>This allows you to quickly switch between different scenarios without having to reconfigure everything from scratch.',
            }
          },
          noexplain: 'No help available for this tab',
        },
        inputarea:{
          reset: 'Reset',
          send: 'Send',
          placeholder: 'Type your message here',
          usevoice: 'Use Voice',
          usetext: 'Use Text',
          suggestions: 'Suggestions',
        }
      }
    }
  },
  de: {
    simulator: {
      atccomponent: {
        paidnotice: 'Der Simulator ist nur für zahlende Nutzer zugänglich',
        verifiednotice: 'Der Simulator ist nur für verifizierte Nutzer zugänglich',
        sessionloaded: 'Sitzung geladen',
        licensemissing: 'Simulator Lizenz ist nicht verfügbar',
        demoused: 'Du hast Zugang zu {transmissions} Übertragungen pro Tag, aber du kannst auf einen Vollplatz upgraden, um unbegrenzten Zugang zu erhalten.',
        purchase: {
          seat: 'Kaufe einen Vollplatz',
          simulator: 'Kaufe die Simulator Lizenz',
        },
        efb:{
          tab: {
            flight: 'Flug',
            instruments: 'Instrumente',
            flightplan: 'Flugplan',
            settings: 'Einstellungen',
            sessions: 'Sitzungen',
          },
          tabs: {
            flight: {
              airplane: 'Flugzeug',
              callsign: 'Rufzeichen/Registrierung',
              icao: 'Startflughafen (ICAO-Code)',
              flightrule: 'Flugregel',
              notes: 'Beachte, dass diese Daten dem ATC nicht bekannt sind, sofern sie nicht übermittelt wurden.',
            },
            flightplan: {
              starting_aerodrome: 'Startflugplatz (ICAO-Code)',
              unknown_distance: 'Unbekannte Distanz',
              title_runway_heading: 'Pistenrichtung',
              destination_aerodrome: 'Zielflugplatz (ICAO-Code)',
            },
            settings: {
              blur:'ATC-Nachrichten verwaschen',
              radioquality:'Simuliere Funkqualität',
              autochange:'Frequenz automatisch wechseln',
              resetaircraft:'Flugzeug bei Zurücksetzen behalten',
              resetcallsign:'Rufzeichen bei Zurücksetzen behalten',
            },
            instruments:{
              transponder: 'Transponder',
              frequency_hint: 'Finde deine Frequenzen auf unserer Tool-Seite <a href="{link}" target="_blank" class="ui-link blue">hier</a>',
              active_frequency: 'Aktive Frequenz',
              alternate_frequency: 'Alternative Frequenz',
              transpondermode: 'Transponder Modus',
              illumination: 'Beleuchtung',
              switchbeacon: 'Antikollisionslicht',
              switchnav: 'Navigationslichter',
              switchstrobe: 'Stroboskoplichter',
              switchlanding: 'Landelichter',
              switchtaxi: 'Rolllichter',
            },
            sessions: {
              firsttransmission: 'Erste Übertragung',
              select: 'Auswählen',
              transmissions: 'Übertragungen',
              hoursago: 'Stunden her',
              minutesago: 'Minuten her',
              nosessions: 'Keine Sitzungen gefunden'
            }
          },
          explaintab: 'Erkläre diesen Tab',
          explain: {
            tabflight: {
              airplane: 'Hier wählst du das Flugzeug deiner Wahl aus.<br><br>Beachte, dass dich die Flugsicherung möglicherweise nicht mit einer 747 von einem Grasstreifen starten lässt.',
              callsign: 'Dies ist das Rufzeichen, das du verwenden musst, wenn du mit der Flugsicherung sprichst.<br><br>Es ist erforderlich, das Rufzeichen im ICAO-Format auszusprechen.<br><br>Beispiel: <strong>G-ABCD</strong> wird als <strong>Golf Alfa Bravo Charlie Delta</strong> ausgesprochen',
              icao: 'Dies ist der ICAO-Code des Flughafens, an dem du dich befindest.<br><br>Du musst einen korrekten Flugplatzcode angeben',
              flightrule: 'Dies sind die Flugregeln, unter denen du fliegst.<br><br>VFR = Sichtflugregeln<br>IFR = Instrumentenflugregeln',
            },
            tabinstruments: {
              activefreq: 'Dies ist die Frequenz, die du derzeit verwendest, um mit der Flugsicherung zu kommunizieren.',
              swapper: 'Mit dieser Schaltfläche kannst du die aktive und die alternative Frequenz tauschen.',
              alternatefreq: 'Dies ist die Frequenz, die du derzeit nicht verwendest, um mit der Flugsicherung zu kommunizieren.',
              squawk: 'Der Squawk-Code ist ein vierstelliger Code, der von der Flugsicherung zugewiesen wird, um dein Flugzeug auf dem Radar zu identifizieren.',
              mode: 'Dies ist der Modus deines Transponders. Er kann je nach Situation auf verschiedene Modi eingestellt werden.',
              illumination: 'Dies ist die Beleuchtung deiner Flugzeuglichter. Es ist wichtig, sie einzuschalten, wenn du nachts oder bei schlechten Sichtverhältnissen fliegst.',
            },
            tabflightplan: {
              startingaerodrome: 'Dies ist der ICAO-Code des Flugplatzes, von dem du startest.<br><br>Du musst einen korrekten Flugplatzcode angeben',
              distance: 'Dies ist die Entfernung zwischen deinem Startflugplatz und deinem Zielflugplatz.<br><br>Wenn "Unbekannte Distanz" angezeigt wird, bedeutet dies, dass einer der Flugplätze nicht gültig ist.',
              heading: 'Dies ist die Richtung vom Startflugplatz zum Zielflugplatz.<br><br>Der Flug wird ungefähr in dieser Richtung ausgerichtet sein.',
              swap: 'Mit dieser Schaltfläche kannst du den Start- und Zielflugplatz tauschen.',
              destinationaerodrome: 'Dies ist der ICAO-Code des Flugplatzes, zu dem du fliegst.<br><br>Du musst einen korrekten Flugplatzcode angeben',
            },
            tabsettings: {
              blur: 'Verwasche die Übertragungen, um das Lesen zu verhindern und das Zuhören zu erzwingen.',
              radioquality: 'Diese Einstellung simuliert die Qualität der Funkkommunikation, indem sie statische Geräusche und Aussetzer hinzufügt.',
              autochange: 'Diese Einstellung ermöglicht den automatischen Frequenzwechsel, wenn dies von der Flugsicherung angeordnet wird.',
              resetaircraft: 'Diese Einstellung behält dein ausgewähltes Flugzeug bei, wenn du den Simulator zurücksetzt.',
              resetcallsign: 'Diese Einstellung behält dein eingegebenes Rufzeichen bei, wenn du den Simulator zurücksetzt.',
            },
            tabsessions:{
              tabexplain: 'Hier kannst du frühere Sitzungen des Simulators laden.<br><br>Dies ermöglicht es dir, schnell zwischen verschiedenen Szenarien zu wechseln, ohne alles von Grund auf neu konfigurieren zu müssen.',
            }
          },
          noexplain: 'Für diesen Tab ist keine Hilfe verfügbar',
        },
        inputarea:{
          reset: 'Zurücksetzen',
          send: 'Senden',
          placeholder: 'Geben Sie Ihre Nachricht hier ein',
          usevoice: 'Sprache verwenden',
          usetext: 'Text verwenden',
          suggestions: 'Vorschläge',
        }
      }
    }
  },
  es: {
    simulator: {
      atccomponent: {
        paidnotice: 'El simulador solo está accesible para usuarios de pago',
        verifiednotice: 'El simulador solo está accesible para usuarios verificados',
        sessionloaded: 'Sesión cargada',
        licensemissing: 'La licencia del simulador no está disponible',
        demoused: 'Tienes acceso a {transmissions} transmisiones al día, pero puedes actualizar a un asiento completo para obtener acceso ilimitado.',
        purchase: {
          seat: 'Compra un asiento completo',
          simulator: 'Compra la licencia del simulador',
        },
        efb:{
          tab: {
            flight: 'Vuelo',
            instruments: 'Instrumentos',
            flightplan: 'Plan de vuelo',
            settings: 'Ajustes',
            sessions: 'Sesiones',
          },
          tabs: {
            flight: {
              airplane: 'Avión',
              callsign: 'Indicativo/Matricula',
              icao: 'Aeropuerto de salida (código ICAO)',
              flightrule: 'Regla de vuelo',
              notes: 'Tenga en cuenta que estos datos no son conocidos por ATC si no se transmiten o son observables.',
            },
            flightplan: {
              starting_aerodrome: 'Aeródromo de salida (código ICAO)',
              unknown_distance: 'Distancia desconocida',
              title_runway_heading: 'Orientación de la pista',
              destination_aerodrome: 'Aeródromo de destino (código ICAO)',
            },
            settings: {
              blur:'Desenfocar mensajes de ATC',
              radioquality:'Simular calidad de radio',
              autochange:'Cambio automático de frecuencia',
              resetaircraft:'Mantener avión al reiniciar',
              resetcallsign:'Mantener indicativo al reiniciar',
            },
            instruments:{
              transponder: 'Transpondedor',
              frequency_hint: 'Encuentra tus frecuencias en nuestra página de herramientas <a href="{link}" target="_blank" class="ui-link blue">aquí</a>',
              active_frequency: 'Frecuencia activa',
              alternate_frequency: 'Frecuencia alternativa',
              transpondermode: 'Modo del transpondedor',
              illumination: 'Iluminación',
              switchbeacon: 'Baliza',
              switchnav: 'Navegación',
              switchstrobe: 'Estroboscópicas',
              switchlanding: 'Aterrizaje',
              switchtaxi: 'Rodaje',
            },
            sessions: {
              firsttransmission: 'Primera transmisión',
              select: 'Seleccionar',
              transmissions: 'Transmisiones',
              hoursago: 'horas ago',
              minutesago: 'minutos ago',
              nosessions: 'No se encontraron sesiones'
            }
          },
          explaintab: 'Explicar esta pestaña',
          explain: {
            tabflight: {
              airplane: 'Aquí seleccionas el avión de tu elección.<br><br>Tenga en cuenta que ATC puede no dejarle salir con un 747 desde una pista de hierba.',
              callsign: 'Este es el indicativo que necesitarás usar al hablar con ATC.<br><br>Se requiere pronunciar el indicativo en formato ICAO.<br><br>Ejemplo: <strong>G-ABCD</strong> se pronunciará como <strong>Golf Alfa Bravo Charlie Delta</strong>',
              icao: 'Este es el código ICAO del aeropuerto en el que te encuentras.<br><br>Se requiere proporcionar un código de aeródromo correcto',
              flightrule: 'Esta es la regla de vuelo bajo la cual vuelas.<br><br>VFR = Reglas de vuelo visual<br>IFR = Reglas de vuelo por instrumentos',
            },
            tabinstruments: {
              activefreq: 'Esta es la frecuencia que estás utilizando actualmente para comunicarte con ATC.',
              swapper: 'Este botón te permite intercambiar las frecuencias activa y alternativa.',
              alternatefreq: 'Esta es la frecuencia que no estás utilizando actualmente para comunicarte con ATC.',
              squawk: 'El código squawk es un código de cuatro dígitos asignado por ATC para identificar tu aeronave en el radar.',
              mode: 'Este es el modo de tu transpondedor. Puede configurarse en diferentes modos según la situación.',
              illumination: 'Esta es la iluminación de las luces de tu aeronave. Es importante tenerlas encendidas al volar de noche o en condiciones de baja visibilidad.',
            },
            tabflightplan: {
              startingaerodrome: 'Este es el código ICAO del aeródromo desde el que estás partiendo.<br><br>Se requiere proporcionar un código de aeródromo correcto',
              distance: 'Esta es la distancia entre tu aeródromo de partida y tu aeródromo de destino.<br><br>Si muestra "Distancia desconocida", significa que uno de los aeródromos no es válido.',
              heading: 'Esta es la dirección desde el aeródromo de partida hasta el aeródromo de destino.<br><br>El vuelo estará aproximadamente alineado con esta dirección.',
              swap: 'Este botón te permite intercambiar los aeródromos de partida y destino.',
              destinationaerodrome: 'Este es el código ICAO del aeródromo al que estás volando.<br><br>Se requiere proporcionar un código de aeródromo correcto',
            },
            tabsettings: {
              blur: 'Desenfoca las transmisiones para evitar la lectura y forzar la escucha.',
              radioquality: 'Esta configuración simula la calidad de la comunicación por radio, añadiendo estática y cortes.',
              autochange: 'Esta configuración permite el cambio automático de frecuencia cuando lo indique ATC.',
              resetaircraft: 'Esta configuración mantiene tu avión seleccionado al reiniciar el simulador.',
              resetcallsign: 'Esta configuración mantiene tu indicativo introducido al reiniciar el simulador.',
            },
            tabsessions:{
              tabexplain: 'Aquí puedes cargar sesiones anteriores del simulador.<br><br>Esto te permite cambiar rápidamente entre diferentes escenarios sin tener que reconfigurar todo desde cero.',
            }
          },
          noexplain: 'No hay ayuda disponible para esta pestaña',
        },
        inputarea:{
          reset: 'Reiniciar',
          send: 'Enviar',
          placeholder: 'Escribe tu mensaje aquí',
          usevoice: 'Usar voz',
          usetext: 'Usar texto',
          suggestions: 'Sugerencias',
        }
      }
    }
  },
  uk: {
    simulator: {
      atccomponent: {
        paidnotice: 'Симулятор доступний лише для платних користувачів',
        verifiednotice: 'Симулятор доступний лише для перевірених користувачів',
        sessionloaded: 'Сесію завантажено',
        licensemissing: 'Ліцензія симулятора недоступна',
        demoused: 'Ви маєте доступ до {transmissions} трансляцій на день, але ви можете оновити до повного місця, щоб отримати необмежений доступ.',
        purchase: {
          seat: 'Придбати повне місце',
          simulator: 'Придбати ліцензію симулятора',
        },
        efb:{
          tab: {
            flight: 'Політ',
            instruments: 'Інструменти',
            flightplan: 'План польоту',
            settings: 'Налаштування',
            sessions: 'Сесії',
          },
          tabs: {
            flight: {
              airplane: 'Літак',
              callsign: 'Позивний/Реєстрація',
              icao: 'Аеропорт вильоту (код ICAO)',
              flightrule: 'Правило польоту',
              notes: 'Зверніть увагу, що ці дані не відомі ATC, якщо вони не передані або не спостерігаються.',
            },
            flightplan: {
              starting_aerodrome: 'Аеродром вильоту (код ICAO)',
              unknown_distance: 'Невідома відстань',
              title_runway_heading: 'Напрямок злітно-посадкової смуги',
              destination_aerodrome: 'Аеродром призначення (код ICAO)',
            },
            settings: {
              blur:'Розмиття повідомлень ATC',
              radioquality:'Імітація якості радіозв\'язку',
              autochange:'Автоматична зміна частоти',
              resetaircraft:'Зберегти літак при скиданні',
              resetcallsign:'Зберегти позивний при скиданні',
            },
            instruments:{
              transponder: 'Транспондер',
              frequency_hint: 'Знайдіть свої частоти на нашій сторінці інструментів <a href="{link}" target="_blank" class="ui-link blue">тут</a>',
              active_frequency: 'Активна частота',
              alternate_frequency: 'Альтернативна частота',
              transpondermode: 'Режим транспондера',
              illumination: 'Освітлення',
              switchbeacon: 'Маяк',
              switchnav: 'Навігація',
              switchstrobe: 'Стробоскопічні',
              switchlanding: 'Посадкові',
              switchtaxi: 'Руління',
            },
            sessions: {
              firsttransmission: 'Перша трансляція',
              select: 'Вибрати',
              transmissions: 'Трансляції',
              hoursago: 'годин тому',
              minutesago: 'хвилин тому',
              nosessions: 'Сесії не знайдено'
            }
          },
          explaintab: 'Пояснити цю вкладку',
          explain: {
            tabflight: {
              airplane: 'Тут ви обираєте літак на свій вибір.<br><br>Зверніть увагу, що ATC може не дозволити вам вилетіти на 747 з трав\'яної смуги.',
              callsign: 'Це позивний, який вам потрібно буде використовувати при спілкуванні з ATC.<br><br>Необхідно вимовляти позивний у форматі ICAO.<br><br>Приклад: <strong>G-ABCD</strong> вимовляється як <strong>Golf Alfa Bravo Charlie Delta</strong>',
              icao: 'Це код ICAO аеропорту, в якому ви перебуваєте.<br><br>Необхідно надати правильний код аеродрому',
              flightrule: 'Це правило польоту, за яким ви летите.<br><br>VFR = Правила візуального польоту<br>IFR = Правила інструментального польоту',
            },
            tabinstruments: {
              activefreq: 'Це частота, яку ви зараз використовуєте для зв\'язку з ATC.',
              swapper: 'Ця кнопка дозволяє вам обміняти активні та альтернативні частоти.',
              alternatefreq: 'Це частота, яку ви зараз не використовуєте для зв\'язку з ATC.',
              squawk: 'Код Squawk - це чотиризначний код, призначений ATC для ідентифікації вашого літака на радарі.',
              mode: 'Це режим вашого транспондера. Він може бути налаштований на різні режими залежно від ситуації.',
              illumination: 'Це освітлення вогнів вашого літака. Важливо, щоб вони були увімкнені під час польоту вночі або в умовах поганої видимості.',
            },
            tabflightplan: {
              startingaerodrome: 'Це код ICAO аеродрому, з якого ви вилітаєте.<br><br>Необхідно надати правильний код аеродрому',
              distance: 'Це відстань між вашим аеродромом вильоту та аеродромом призначення.<br><br>Якщо показує "Невідома відстань", це означає, що один з аеродромів недійсний.',
              heading: 'Це напрямок від аеродрому вильоту до аеродрому призначення.<br><br>Польот буде приблизно вирівняний за цим напрямком.',
              swap: 'Ця кнопка дозволяє вам обміняти аеродроми вильоту та призначення.',
              destinationaerodrome: 'Це код ICAO аеродрому, до якого ви летите.<br><br>Необхідно надати правильний код аеродрому',
            },
            tabsettings: {
              blur: 'Розмиває трансляції, щоб запобігти читанню і змусити слухати.',
              radioquality: 'Ця настройка імітує якість радіозв\'язку, додаючи статичні шуми та перебої.',
              autochange: 'Ця настройка дозволяє автоматично змінювати частоту за вказівкою ATC.',
              resetaircraft: 'Ця настройка зберігає вибраний вами літак при скиданні симулятора.',
              resetcallsign: 'Ця настройка зберігає введений вами позивний при скиданні симулятора.',
            },
            tabsessions:{
              tabexplain: 'Тут ви можете завантажити попередні сесії симулятора.<br><br>Це дозволяє швидко перемикатися між різними сценаріями, не налаштовуючи все заново.',
            }
          },
          noexplain: 'Допомога для цієї вкладки недоступна',
        },
        inputarea:{
          reset: 'Скинути',
          send: 'Надіслати',
          placeholder: 'Введіть ваше повідомлення тут',
          usevoice: 'Використовувати голос',
          usetext: 'Використовувати текст',
          suggestions: 'Пропозиції',
        }
      }
    }
  }
}
